export default {
  server: window._ENV.REACT_APP_API_BASE_URL,

  endPoints: {
    sentences: {
      sentencesList: "/sentences",
    },
    notes: {
      notesList: "/notes",
    },
    extendedField: {
      extendedFieldList: "/extendedField",
    },
    enforcement: {
      enforcements: "/Enforcement",
    },
    systemService: {
      CaseDetails: "/CaseDetails",
      ARsEntInfo: "/ARsEntInfo",
    },
    metadata: {
      metadata: "/system/domainView/metadata",
    },
    arService: {
      caseProperties: "/cases",
    },
  },
};

export * from "./PaymentAgreementActions";
export * from "./ActivityExecution";
export * from "./WorkflowExecution";
export * from "./DomainView";
export * from "./Test";
export * from "./Handler";
export * from "./GDPRComment";
export * from "./CaseView";
export * from "./WorkFlowState";
